<script>
  import ProductPrice from '@/components/Ecommerce/Products/ProductPrice'

  export default {
    components: {
      ProductPrice
    },
    props: {
      coupon: {
        type: String,
        default: null
      },
      amount: {
        type: Number,
        required: true
      },
      price: {
        type: Number,
        required: false,
        default: null
      }
    }
  }
</script>

<template>
  <div class="space-y-5">
    <div class="flex items-center justify-between">
      <span class="flex flex-col">
        Korting
        <transition
          name="fade"
          mode="out-in"
        >
          <span v-show="coupon">
            ({{ coupon }})
          </span>
        </transition>
      </span>
      <ProductPrice
        :price="price"
        :discount="amount"
        show-decimals
      />
    </div>
  </div>
</template>

<style scoped>

</style>
